export enum Phase {
  COMING_SOON = 0,
  FLASH_SALE = 1,
  PUBLIC_SALE = 2,
  CLOSED = 3,
}
